import { courseServiceApi } from "../../apis/courseService.api";
import { COURSE_API_TAGS } from "../../app.constants";
import type {
  GeneratePromotionCode,
  PromotionDetailsResponse,
  PromotionParams,
  PromotionResponse,
  PromotionsDto,
} from "./adminPromotions.types";

const PROMOTION_URL = "/admin/promotions";

export const adminPromotionsApi = courseServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    createPromotions: builder.mutation<void, PromotionsDto>({
      query: (body) => ({
        url: PROMOTION_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: COURSE_API_TAGS.PROMOTIONS }],
    }),
    getPromotions: builder.query<PromotionResponse, PromotionParams>({
      query: (params) => ({
        url: PROMOTION_URL,
        method: "GET",
        params,
      }),
      providesTags: () => [{ type: COURSE_API_TAGS.PROMOTIONS }],
    }),
    getSinglePromotion: builder.query<PromotionDetailsResponse, string>({
      query: (id: string) => ({
        url: `${PROMOTION_URL}/${id}`,
        method: "GET",
      }),
      providesTags: (_, __, id) => [{ type: COURSE_API_TAGS.PROMOTIONS, id }],
    }),
    updatePromotion: builder.mutation<
      void,
      { body: PromotionsDto; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${PROMOTION_URL}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (_, __, { id }) => [
        { type: COURSE_API_TAGS.PROMOTIONS },
        { type: COURSE_API_TAGS.PROMOTIONS, id },
      ],
    }),
    deletePromotion: builder.mutation<void, string>({
      query: (id) => ({
        url: `${PROMOTION_URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (_, __, id) => [
        { type: COURSE_API_TAGS.PROMOTIONS },
        { type: COURSE_API_TAGS.PROMOTIONS, id },
      ],
    }),
    generatePromotionCode: builder.mutation<GeneratePromotionCode, string>({
      query: (id) => ({
        url: `${PROMOTION_URL}/${id}/generate-code`,
        method: "POST",
        headers: {
          "Cache-Control": "no-cache",
        },
      }),
    }),
  }),
});

export const {
  useCreatePromotionsMutation,
  useGetPromotionsQuery,
  useGetSinglePromotionQuery,
  useUpdatePromotionMutation,
  useDeletePromotionMutation,
  useGeneratePromotionCodeMutation,
} = adminPromotionsApi;
